import { render } from "./SystemHomeSectionDetail.vue?vue&type=template&id=ae3cef26&scoped=true"
import script from "./SystemHomeSectionDetail.vue?vue&type=script&lang=js"
export * from "./SystemHomeSectionDetail.vue?vue&type=script&lang=js"

import "./SystemHomeSectionDetail.vue?vue&type=style&index=0&id=ae3cef26&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae3cef26"]])

export default __exports__